import { Routes, Route, Navigate, useParams } from "react-router-dom";
import { supportedLanguages } from "@/lib/i18n";
import { getPageFromSlug } from "@/lib/slugUtils";
import LanguageProvider from "@/components/LanguageProvider";
import ScrollToTop from "@/components/ScrollToTop";
import Index from "./pages/Index";
import About from "./pages/About";
import Services from "./pages/Services";
import Portfolio from "./pages/Portfolio";
import Contact from "./pages/Contact";
import PriceForm from "./pages/PriceForm";
import FilloutExpert from "./pages/FilloutExpert";
import JotformExpert from "./pages/JotformExpert";
import IndustryPage from "./pages/Industry";
import TenReasons from "./pages/TenReasons";
import PricingGuide from "./pages/PricingGuide";
import BuildYourOwn from "./pages/BuildYourOwn";
import InteractiveLeadGen from "./pages/InteractiveLeadGen";
import CraftsmenCalculator from "./pages/CraftsmenCalculator";
import B2BLeadGen from "./pages/B2BLeadGen";
import InteractiveCalculator from "./pages/InteractiveCalculator";
import CalculatorExamples from "./pages/CalculatorExamples";
import CalculatorMistakes from "./pages/CalculatorMistakes";
import NotFound from "./pages/NotFound";

// Component to handle dynamic routing based on translated slugs
const DynamicPageRoute = () => {
  const { lang, slug } = useParams<{ lang: string; slug: string }>();
  
  if (!lang || !slug) {
    return <NotFound />;
  }

  const page = getPageFromSlug(slug, lang);
  
  switch (page) {
    case 'about': return <About />;
    case 'services': return <Services />;
    case 'portfolio': return <Portfolio />;
    case 'contact': return <Contact />;
    case 'price-form': return <PriceForm />;
    case 'jotform-expert': return <JotformExpert />;
    case 'fillout-expert': return <FilloutExpert />;
    case 'industry-real-estate': return <IndustryPage industry="real-estate" />;
    case 'industry-ecommerce': return <IndustryPage industry="ecommerce" />;
    case 'industry-restaurants': return <IndustryPage industry="restaurants" />;
    case 'industry-financial': return <IndustryPage industry="financial" />;
    case 'industry-agencies': return <IndustryPage industry="agencies" />;
    case 'industry-construction': return <IndustryPage industry="construction" />;
    case '10-reasons': return <TenReasons />;
    case 'pricing-guide': return <PricingGuide />;
    case 'build-your-own': return <BuildYourOwn />;
    case 'interactive-lead-gen': return <InteractiveLeadGen />;
    case 'craftsmen-calculator': return <CraftsmenCalculator />;
    case 'b2b-lead-gen': return <B2BLeadGen />;
    case 'interactive-calculator': return <InteractiveCalculator />;
    case 'calculator-examples': return <CalculatorExamples />;
    case 'calculator-mistakes': return <CalculatorMistakes />;
    default: 
      return <NotFound />;
  }
};

export default function AppRoutes() {
  return (
    <>
      <ScrollToTop />
      <LanguageProvider>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/:lang" element={<Index />} />
          <Route path="/:lang/:slug" element={<DynamicPageRoute />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </LanguageProvider>
    </>
  );
}
